export const isString = (input: any): input is string => typeof input === 'string';
